import { createSelector } from "reselect"
import { get, last, first, map, chain, size, some } from "lodash"
import { computeFactorCategories } from "helpers/factors"
import { getFactorCalculationResultsByDate } from "modules/factor-trends/helpers"
import { getSelectedViews, getSelectedViewsFactors } from "modules/factor-trends/selectors/factors"

export const getFactorsPerformance = (state) => get(state, "global.data.factorTrendsPerformance.data.model.factors")

export const getFactorsPerformanceByDate = createSelector(
  [getFactorsPerformance],
  (factors) => getFactorCalculationResultsByDate(factors, "performance"),
)

export const getPerformanceHistory = createSelector(
  [getFactorsPerformanceByDate, getSelectedViews, getSelectedViewsFactors],
  (performanceHistory, selectedViews, selectedViewsFactors) => map(performanceHistory, (daily, date) => {
    let factors = daily

    if (size(selectedViews)) {
      factors = chain(daily)
        .filter(factor => some(selectedViewsFactors, item => item.id === factor.id))
        .map(factor => ({ ...factor, customView: true }))
        .concat(factors)
        .value()
    }

    factors = chain(factors)
      .keyBy(factor => factor.id)
      .mapValues(factor => factor.percentPriceChangeCumulative)
      .value()

    return {
      date,
      factors,
      categories: computeFactorCategories(factors, selectedViews),
    }
  }),
)

export const getCurrentPerformance = createSelector(
  [getPerformanceHistory],
  (performanceHistory) => last(performanceHistory),
)

export const getFirstPerformanceDate = createSelector(
  [getPerformanceHistory],
  (performanceHistory) => get(first(performanceHistory), "date", null),
)
